import React from 'react';
import { Link } from 'react-router-dom';
import { postExcerpt, postReadTime, postTitle } from '../utils/postContent';
import './BlogCard.css';

const ArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);



const BlogCard = ({ post, variant = 'default' }) => {
  const { image, category, date, slug } = post;
  const title = postTitle(post.title);
  const readTime = postReadTime(post);
  const excerpt = postExcerpt(post, variant === 'featured' ? 240 : 170);

  const formatDate = (dateString) => new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });

  const isFeatured = variant === 'featured';
  const cardLink = `/blog/${slug}`;

  return (
    <article className={`blog-card ${isFeatured ? 'blog-card--featured' : ''}`}>
      <div className="blog-card-image">
        <img
          src={image}
          alt={`Cover image for ${title}`}
          loading="lazy"
          width="900"
          height={isFeatured ? '480' : '240'}
        />
        <div className="blog-card-image-overlay" aria-hidden="true" />
        <div className="blog-card-category" aria-label={`Category: ${category}`}>
          {category}
        </div>

      </div>

      <div className="blog-card-content">
        <div className="blog-card-meta">
          <span className="blog-card-date">
            <time dateTime={date}>{formatDate(date)}</time>
          </span>
          {readTime && (
            <>
              <span className="blog-card-meta-sep" aria-hidden="true">·</span>
              <span className="blog-card-read-time">{readTime}</span>
            </>
          )}
        </div>

        <h3 className="blog-card-title">
          <Link to={cardLink} aria-label={`Read ${title}`}>{title}</Link>
        </h3>

        <p className="blog-card-excerpt">{excerpt}</p>

        <Link to={cardLink} className="blog-card-cta" aria-label={`Read ${title}`}>
          Read More <ArrowRight />
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
